import React, {useState, useEffect} from 'react';
import useTitle from '@/hook/useTitle';
import {ThreeColumnLayout} from '@/component';
import styles from './index.module.less';
import Content from '@/page/conversation/ConPage/Content';
import _ from 'lodash';
import UserList from '@/page/conversation/ConPage/UserList';
import {Tabs, Input} from 'antd';
import ConversationContext from '@/page/conversation/ConPage/conversationContext';
import {useAuthStore} from '@/context/auth';

const {TabPane} = Tabs;
const {Search} = Input;

const tabs = [
    {name: '员工', key: 0},
    {name: '客户', key: 1},
];

const userReceiveTabs = [
    {name: '内部联系人', key: 2},
    {name: '客户', key: 1},
    {name: '群聊', key: 3},
];

const customerReceiveTabs = [
    {name: '内部联系人', key: 2},
    {name: '群聊', key: 3},
];

let receiveTabs = [...userReceiveTabs];

export default function SessionRetainedPage() {
    const [authStore] = useAuthStore();
    const userId = _.get(authStore, 'user.extId');
    useTitle('会话存档');
    const [from, setFrom] = useState({});
    // 用户类型 0 为内部用户  1 为客户
    const [fromType, setFromType] = useState(0);
    const [receive, setReceive] = useState({});
    // 1 2代表单聊 3 代表群聊
    const [receiveType, setReceiveType] = useState(2);

    const [filterParams, setFilterParams] = useState({
        s: '',
        userId,
        size: 15,
    });
    const [filterSecondParams, setFilterSecondParams] = useState({
        s: '',
        size: 15,
    });

    function changeFromTab(type) {
        setFrom({});
        setReceive({});
        setFromType(parseInt(type, 10));
        receiveTabs = parseInt(type, 10) === 0 ? [...userReceiveTabs] : [...customerReceiveTabs];
    }

    function changeReceiveTab(type) {
        setReceive({});
        setReceiveType(parseInt(type, 10));
        setFilterSecondParams({s: '', size: 15});
    }

    function onSecondSearch(e) {
        let filter = {...filterSecondParams};
        filter.s = e;
        setFilterSecondParams(filter);
    }

    function onSearch(e) {
        let filter = {...filterParams};
        filter.s = e;
        setFilterParams(filter);
    }

    function renderSearch() {
        return <Search placeholder="请输入..." className={styles.search} onSearch={onSearch} />;
    }

    return (
        <ThreeColumnLayout className={styles.conPage}>
            <ConversationContext.Provider value={{from, setFrom, receive, setReceive, fromType}}>
                <ThreeColumnLayout.SidePanel>
                    <ThreeColumnLayout.PanelHeader title="高级会话查询" />
                    <ThreeColumnLayout.PanelContent
                    // style={{overflowY: 'auto', overflowX: 'hidden'}}
                    >
                        {renderSearch()}
                    </ThreeColumnLayout.PanelContent>

                    <Tabs onChange={changeFromTab} centered={true} className={styles.from}>
                        {tabs.map((item, i) => (
                            <TabPane tab={item.name} key={item.key}>
                                {fromType === item.key && (
                                    <div
                                        style={{
                                            // overflowY: 'auto',
                                            overflowX: 'hidden',
                                            // height: '80vh',
                                        }}
                                    >
                                        <UserList
                                            url={`/cons/list/${fromType}`}
                                            key={i}
                                            filterParams={filterParams}
                                        />
                                    </div>
                                )}
                            </TabPane>
                        ))}
                    </Tabs>
                </ThreeColumnLayout.SidePanel>
                <ThreeColumnLayout.SidePanel>
                    <ThreeColumnLayout.PanelHeader title={from.name ? from.name : '未选择用户'} />
                    <ThreeColumnLayout.PanelContent
                    // style={{overflowY: 'auto', overflowX: 'hidden'}}
                    >
                        {/*<div className={styles.title}>{from.name ? from.name : '未选择用户'}</div>*/}
                        <Search
                            placeholder="请输入..."
                            className={styles.search}
                            onSearch={onSecondSearch}
                        />
                    </ThreeColumnLayout.PanelContent>
                    <Tabs onChange={changeReceiveTab} centered={true} className={styles.from}>
                        {receiveTabs.map((item, i) => (
                            <TabPane tab={item.name} key={item.key}>
                                {receiveType == item.key && (
                                    <div
                                        style={{
                                            //overflowY: 'auto',
                                            overflowX: 'hidden',
                                            //height: '80vh',
                                        }}
                                    >
                                        <UserList
                                            url={
                                                !_.isEmpty(from)
                                                    ? `/cons/search/contact/${
                                                          fromType === 0
                                                              ? from.extId
                                                              : from.externalUserId
                                                      }/${receiveType}/${fromType}`
                                                    : null
                                            }
                                            key={i}
                                            receiveType={receiveType}
                                            filterParams={filterSecondParams}
                                            type={1}
                                        />
                                    </div>
                                )}
                            </TabPane>
                        ))}
                    </Tabs>
                </ThreeColumnLayout.SidePanel>
                <ThreeColumnLayout.ContentPanel
                    style={{display: 'block', background: '#F8F8F8', overflowY: 'auto'}}
                >
                    <div className={styles.title}>
                        {!_.isEmpty(receive) ? receive.name + '会话' : '暂无会话'}
                    </div>
                    <Content
                        receiveType={receiveType}
                        receive={receive}
                        from={from}
                        fromType={fromType}
                    />
                </ThreeColumnLayout.ContentPanel>
            </ConversationContext.Provider>
        </ThreeColumnLayout>
    );
}
